(() => {
  const form = document.querySelector("[data-filters]");
  const sortSelect = document.querySelector("[data-sort]");

  // ---- Mobile filter drawer ----
  const openBtns = document.querySelectorAll("[data-filters-open]");
  const closeBtns = document.querySelectorAll("[data-filters-close]");
  const openDrawer = () => document.body.classList.add("sora-filters-open");
  const closeDrawer = () => document.body.classList.remove("sora-filters-open");
  openBtns.forEach(b => b.addEventListener("click", openDrawer));
  closeBtns.forEach(b => b.addEventListener("click", closeDrawer));
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeDrawer(); });

  // ---- Build a filtered URL from the form (drop empty params) ----
  function urlFromForm() {
    const base = (form && form.getAttribute("action")) || window.location.pathname;
    const clean = new URLSearchParams();
    if (form) {
      const fd = new FormData(form);
      for (const [k, v] of fd.entries()) {
        if (v !== "" && v != null) clean.append(k, v);
      }
    }
    if (sortSelect && sortSelect.value) clean.set("sort_by", sortSelect.value);
    const qs = clean.toString();
    return qs ? `${base}?${qs}` : base;
  }

  // ---- Apply (full navigation — robust, preserves SEO + infinite scroll) ----
  function apply() {
    document.body.classList.add("sora-collection--loading");
    window.location.href = urlFromForm();
  }

  if (form) {
    // checkboxes / radios apply immediately; number (price) applies on change/blur
    form.addEventListener("change", apply);
    // avoid the <noscript> submit path double-firing
    form.addEventListener("submit", e => { e.preventDefault(); apply(); });
  }

  if (sortSelect) {
    sortSelect.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortSelect.value);
      document.body.classList.add("sora-collection--loading");
      window.location.href = url.toString();
    });
  }
})();
